<template>
  <div>
  <Breadcrumbs main="Services" title="Delete Profile" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
              <div class="card-header">
                <h5 style="font-weight: 400">Delete Profile</h5>
                <span>Choosing this option will delete your profile permanently from TAJWay. A new registration will be required subsquently.</span>
              </div>
              <div v-show="step === 1" class="animated fadeIn card-body">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-md-3 col-form-label" for="NewPin">Enter Pin <b class="text-danger">*</b></label>
                    <div class="col-sm-9 col-md-6">
                        <input class="form-control" @paste.prevent @keypress="isNumber" v-model="form.pin"  maxlength="4" min="0" placeholder="Enter Pin *" :type="pinType" />
                        <span @click="showNewPin" class="pull-right show-pin">{{pinType === 'password' ? 'show' : 'hide'}}</span>
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">
                    </label>
                      <div class="col-sm-9">
                          <button type="button" :disabled="loading" @click="deleteUserProfile" class="btn btn-primary mr-2">
                            <div v-if="loading">
                              <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                            </div>
                            <div v-else>
                              Submit <i class="fa fa-check ms-2"></i>
                            </div>
                          </button>
                          <router-link :to="{ name: 'default' }">
                            <button type="reset" class="btn btn-outline-danger">Cancel</button>
                          </router-link>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapActions } from 'vuex';
  import { decrypt } from '@/_services/encryption';
  export default {
    components: {
    },
    data:() => ({
      form: {
        pin: '',
        platform: 1
      },
      pinType: 'password',
      step: 1,
      loading: false
    }),
    computed: {
    },
    mounted() {
      this.$swal({
        title: 'Are you sure?',
        text:`Choosing this option will delete your profile permanently from TAJWay. A new registration will be required subsquently.`,
        showCancelButton: true,
        confirmButtonText: 'Proceed',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn btn-primary',
        confirmButtonClass: 'btn btn-success mr-2',
        buttonsStyling: false,
        type:'info'
      }).then((result) => {
        if(result.value) {
          this.step = 1;
        } else {
          this.$router.push({ name: 'default' });
        }
      });
    },
    methods : {
      ...mapActions('dashboard', ['deleteProfile']),
      ...mapActions('authentication', ['logout']),
      showNewPin () {
        this.pinType = this.pinType === 'password' ? 'text' : 'password';
      },
      async deleteUserProfile() {
        if (this.form.pin === '') {
          this.$swal({
            title:'Error!',
            text: 'Kindly enter your pin',
            type:'error'
          });
        } else {
          try {
            this.loading = true;
            await this.deleteProfile(this.form);
            this.loading = false;
            this.$swal({
              title:'Success!',
              text: 'Profile has been deleted ssuccesfully.',
              type:'success'
            }).then(() => {
              this.$store.dispatch('logout'); 
            });
          } catch (error) {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
              confirmButtonText: 'Ok'
            });
          }
        }
      }
    }
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100% !important;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.vdp-datepicker {
  width: 485px !important;
}
</style>